import { render } from "./DefaultMailTexts.vue?vue&type=template&id=388f65f0"
import script from "./DefaultMailTexts.vue?vue&type=script&lang=js"
export * from "./DefaultMailTexts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__